import React from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

export default function ContactPage() {
  return (
    <div style={{ background: '#000', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '80px 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <h1 style={{ fontSize: 42, fontWeight: 700, marginBottom: 16 }}>Get in <span style={{ color: '#00d55b' }}>Touch</span></h1>
          <p style={{ color: '#888', fontSize: 16, lineHeight: 1.7 }}>If you are interested in integrating MSChat into your website or want to learn more about our chatbot solutions, our team will be happy to assist you.</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 20, marginBottom: 48 }}>
          {[
            { icon: '📧', label: 'Email', value: 'halo@msdiscoveries.com', href: 'mailto:halo@msdiscoveries.com' },
            { icon: '📞', label: 'Phone', value: '+91 9443724724', href: 'tel:+919443724724' },
            { icon: '🕐', label: 'Support Hours', value: 'Mon–Sat, 10AM–6PM IST' }
          ].map(c => (
            <div key={c.label} style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 24, textAlign: 'center' }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{c.icon}</div>
              <div style={{ fontSize: 11, color: '#555', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8 }}>{c.label}</div>
              {c.href
                ? <a href={c.href} style={{ color: '#00d55b', fontSize: 15, fontWeight: 500 }}>{c.value}</a>
                : <div style={{ color: '#fff', fontSize: 14 }}>{c.value}</div>
              }
            </div>
          ))}
        </div>

        <div style={{ background: '#111', border: '1px solid #1e1e1e', borderRadius: 12, padding: 28 }}>
          <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12 }}>Business Enquiries</h3>
          <p style={{ color: '#888', fontSize: 14, lineHeight: 1.7 }}>For partnership opportunities, product integration, or technical support, please contact us through email or phone. Our team will respond as soon as possible.</p>
          <p style={{ color: '#555', fontSize: 13, marginTop: 12 }}>We are committed to helping businesses improve their communication through smart automation.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
